import * as Sentry from '@sentry/react';
import api from 'api';
import store from 'store';

import { State } from 'store';
import IAsync from 'types/IAsync';
import IWorkflowErrorSummary from 'types/IWorkflowErrorSummary';

function setErrorSummaryAsync(wfId: string, errorSummaryAsync: IAsync<IWorkflowErrorSummary>) {
  store.setState((state: State) => ({
    dashboard: {
      ...state.dashboard,
      errorSummaryAsyncMap: {
        ...state.dashboard.errorSummaryAsyncMap,
        [wfId]: errorSummaryAsync,
      },
    },
  }));
}

export default function fetchWorkflowErrorSummary(projectId: string, wfId: string) {
  const errorSummaryAsync = store.getState().dashboard.errorSummaryAsyncMap[wfId] ?? { status: 'INIT' };

  switch (errorSummaryAsync.status) {
    case 'PENDING':
    case 'REFRESH':
      // Already fetching
      return;
    case 'INIT':
    case 'ERROR':
      setErrorSummaryAsync(wfId, { status: 'PENDING' });
      break;
    case 'SUCCESS':
      // Refetch so a reopened dialog shows fresh data
      setErrorSummaryAsync(wfId, { status: 'REFRESH', data: errorSummaryAsync.data });
      break;
  }

  api
    .get(`projects/${projectId}/workflows/${wfId}/error-summary`)
    .json()
    .then(
      (data) => {
        setErrorSummaryAsync(wfId, {
          status: 'SUCCESS',
          data: data as IWorkflowErrorSummary,
        });
      },
      (error) => {
        Sentry.captureException(error);
        setErrorSummaryAsync(wfId, { status: 'ERROR' });
      },
    );
}
